import { _ as __rest, a as __assign } from './tslib.es6-2259bcab.js';
import { c as classNames } from './index-444bb648.js';
import React__default, { createContext, useContext, useRef } from 'react';

var styles = {"container":"Tabs_container_4eebba73","tablist":"Tabs_tablist_4eebba73"};

var TabsContext = createContext(undefined);
var useTabsContext = function () {
    return useContext(TabsContext);
};
var KEYS;
(function (KEYS) {
    KEYS["UP_ARROW"] = "ArrowUp";
    KEYS["DOWN_ARROW"] = "ArrowDown";
    KEYS["LEFT_ARROW"] = "ArrowLeft";
    KEYS["RIGHT_ARROW"] = "ArrowRight";
    KEYS["HOME"] = "Home";
    KEYS["END"] = "End";
})(KEYS || (KEYS = {}));
var Tabs = function (_a) {
    var label = _a.label, selectedTabId = _a.selectedTabId, onTabChange = _a.onTabChange, className = _a.className, children = _a.children, disabled = _a.disabled, otherProps = __rest(_a, ["label", "selectedTabId", "onTabChange", "className", "children", "disabled"]);
    var tabRefs = useRef([]);
    var focusTab = function (index) {
        if (tabRefs.current[index]) {
            tabRefs.current[index].focus();
        }
    };
    var handleFocus = function (e, currentTabIndex) {
        var firstTab = 0;
        var lastTab = tabChildren.length - 1;
        if (e.key === KEYS.RIGHT_ARROW || e.key === KEYS.DOWN_ARROW) {
            var nextIndex = currentTabIndex < lastTab ? currentTabIndex + 1 : firstTab;
            focusTab(nextIndex);
        }
        if (e.key === KEYS.LEFT_ARROW || e.key === KEYS.UP_ARROW) {
            var nextIndex = currentTabIndex > 0 ? currentTabIndex - 1 : lastTab;
            focusTab(nextIndex);
        }
        if (e.key === KEYS.HOME) {
            focusTab(firstTab);
        }
        if (e.key === KEYS.END) {
            focusTab(lastTab);
        }
    };
    var tabChildren = React__default.Children.map(children, function (child, index) {
        if (!React__default.isValidElement(child)) {
            return null;
        }
        return (React__default.createElement(TabsContext.Provider, { value: {
                onTabChange: onTabChange,
                isSelected: function (id) { return id === selectedTabId; },
                onKeyDown: function (e) {
                    return handleFocus(e, index);
                },
                ref: function (ref) {
                    tabRefs.current[index] = ref;
                },
                disabled: disabled,
            } }, child));
    }) || [];
    return (React__default.createElement("div", __assign({ className: classNames(styles.container, disabled && styles.disabled, className) }, otherProps),
        React__default.createElement("div", { role: "tablist", "aria-label": label, className: styles.tablist }, tabChildren)));
};

export { Tabs as T, useTabsContext as u };
